import React from 'react';

const BUNI_LOGO = `${process.env.PUBLIC_URL}/assest/img/${encodeURIComponent('buni logo.png')}`;

function Loader({ label = 'Loading...' }) {
  return (
    <div className="site-loader" role="status" aria-live="polite" aria-label={label}>
      <div className="site-loader-backdrop" />
      <div className="site-loader-content">
        <div className="site-loader-spinner">
          <div className="site-loader-ring" />
          <img src={BUNI_LOGO} alt="Buni Hub" className="site-loader-logo" />
        </div>
        <p className="site-loader-text">{label}</p>
      </div>
    </div>
  );
}

export default Loader;
